
import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
    console.error("Uncaught error:", error, errorInfo);
    this.setState({ error: error });
  }

  public render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="min-h-screen bg-stone-100 flex items-center justify-center p-4">
          <div className="max-w-2xl w-full bg-white rounded-lg shadow-xl p-8 text-center">
            <h1 className="text-3xl font-bold text-red-600 mb-4">Application Error</h1>
            <p className="text-stone-700 text-lg mb-2">
              Oops! The application has encountered a critical error and cannot start.
            </p>
            <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800 p-4 mt-6 text-left rounded-r-lg">
                <p className="font-bold">Most Common Cause:</p>
                <p>This error frequently occurs when the <strong>API Key is missing or invalid</strong>.</p>
                <p className="mt-2 text-sm">Please ensure that the `API_KEY` environment variable is correctly set in your Cloudflare Pages deployment settings.</p>
            </div>
            {this.state.error && (
                <div className="mt-4 p-2 bg-stone-200 text-stone-600 text-xs text-left rounded overflow-x-auto">
                    <pre><code>{this.state.error.toString()}</code></pre>
                </div>
            )}
             <button
                onClick={() => window.location.reload()}
                className="mt-6 px-6 py-2 bg-amber-700 text-white font-semibold rounded-lg shadow-md hover:bg-amber-800 transition-colors"
            >
                Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
